import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { ATTENDANCE_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { DailyDashboardPage } from '@/features/attendance/pages/DailyDashboardPage';
import { dailyDashboardSearchSchema } from '@/features/attendance/types/attendance.types';

export const Route = createFileRoute('/_auth/attendance/')({
  beforeLoad: () => requirePermission(ATTENDANCE_PERMISSIONS.DAILY_DASHBOARD_VIEW),
  validateSearch: dailyDashboardSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Daily Attendance">
      <Suspense fallback={<PageLoader />}>
        <DailyDashboardPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
